import {
  Flex,
  Table,
  Input,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import { FaSortUp, FaSortDown, FaCheckCircle } from 'react-icons/fa'; // Import the up and down arrow icons
import { chakra, Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import MultiSelect from 'components/autocomplete/autocomplete';
import React, { useState, useEffect, useRef } from 'react';
import { EditIcon, AddIcon, ViewIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
import EditModal from './editModal';
// Custom components
import TableWrapper from 'components/tableWrapper/tableWrapper';
import CustomerApi from '../../../../api/customer';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import PageError from 'components/nopermission/PageError';
import moment from 'moment';
import DashboardReportApi from 'api/dashboardreport';

const customerstatusoption = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'UNVERIFIED', label: 'Unverified' },
  { value: 'BLOCKED', label: 'Blocked' },
];

const kycoption = [
  { value: '', label: 'All' },
  { value: 'Aadhaar', label: 'Aadhaar Verified' },
  { value: 'Pan', label: 'Pan Verified' },
];

export default function CheckTable(props) {
  const userType = 'CUSTOMER';
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  //Data Fetching
  // const [data, setData] = useState([]);
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const { getPermissionsForModule } = usePermissions();
  const [permissions, setPermissions] = useState(null);
  const [fetchUserListError, setFetchUserListError] = useState(false);
  const [selectedStatusType, setSelectedStatusType] = useState([customerstatusoption[0]]);
  const [selectedKycType, setSelectedKycType] = useState([kycoption[0]]);
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortKey, setSortKey] = useState('created_at');


  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (e.g., 800ms)
  };
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  const handleSort = (key) => {
    // Toggle the sort direction based on the current state
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';

    // Update the sorting state
    setSortKey(key);
    setSortDirection(newDirection);
    setCurrentPage(1)
    FetchUserList(); // Example of calling the API function with the key and direction
  };

  useEffect(() => {
    const permissions = getPermissionsForModule([Modules.Customer]);
    setPermissions(permissions);
    DashboardReportApi.Notifications();
  }, []);

  const selectedStatusTypeValue = Array.isArray(selectedStatusType)
    ? selectedStatusType?.map((option) => option.value).join(',')
    : selectedStatusType.value;

  const selectedKycTypeValue = Array.isArray(selectedKycType)
    ? selectedKycType?.map((option) => option.value).join(',')
    : selectedKycType.value;



  const FetchUserList = async () => {
    try {
      setLoading(true);
      let response = await CustomerApi.List({
        currentPage,
        itemsPerPage,
        sort: `${sortKey}:${sortDirection}`,
        searchTerm,
        userType,
        selectedStatusTypeValue,
        selectedKycTypeValue
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchUserListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchUserListError(true);
        setList([]);
        setListTotal(0);
      }
    } catch (err) {
      setFetchUserListError(true);
      console.log(err);
      setList([]);
    }
  };
  useEffect(() => {
    if (permissions?.read) {
      FetchUserList();
    }
  }, [searchTerm, currentPage, permissions, selectedStatusTypeValue, selectedKycTypeValue]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedStatusTypeValue, selectedKycTypeValue]);

  console.log('Permissions', permissions);
  console.log('List conatis', list);

  if (!permissions?.read) {
    return <NoPermissionsMessage module={Modules.Customer} />;
  }
  return fetchUserListError ? (
    <PageError />
  ) : (
    <Flex
      height='100%'
      mt='8rem'
      direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={5}
        mb='20px'
        width='100%'
        gap={10}>
        <Flex>
          <Input
            variant='auth'
            minWidth='sm'
            type='text'
            placeholder='Search by Name or Phone No.'
            onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
          />
        </Flex>

        <Flex>
          <MultiSelect
            options={customerstatusoption}
            placeholder='Select Status'
            value={selectedStatusType}
            onChange={setSelectedStatusType}
            isMulti={false}
          />
        </Flex>

        <Flex>
          <MultiSelect
            options={kycoption}
            placeholder='KYC Type'
            value={selectedKycType}
            onChange={setSelectedKycType}
            isMulti={false}
            isClearable={true}
          />
        </Flex>



        <Flex ml='auto'>
          <Tooltip
            label={
              !permissions?.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren>
            <AddModal
              Icon={<AddIcon />}
              head={'Add Customer'}
              func={FetchUserList}
              disabled={!permissions?.create}
            />
          </Tooltip>
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Code
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}
                cursor="pointer" onClick={() => handleSort('name')}
              >
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  <Text>
                    Name
                  </Text>
                  {sortKey === 'name' ? (
                    sortDirection === 'asc' ? (
                      <FaSortUp style={{ fontSize: '14px', fontWeight: 'bold' }} />
                    ) : (
                      <FaSortDown style={{ fontSize: '14px', fontWeight: 'bold' }} />
                    )
                  ) : (
                    <FaSortDown style={{ fontSize: '14px', fontWeight: 'light' }} />
                  )}
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Phone Number
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  E-mail
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}
                cursor="pointer" onClick={() => handleSort('created_at')}
              >
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  <Text>
                    Join Date
                  </Text>
                  {sortKey === 'created_at' ? (
                    sortDirection === 'asc' ? (
                      <FaSortUp style={{ fontSize: '14px', fontWeight: 'bold' }} />
                    ) : (
                      <FaSortDown style={{ fontSize: '14px', fontWeight: 'bold' }} />
                    )
                  ) : (
                    <FaSortDown style={{ fontSize: '14px', fontWeight: 'light' }} />
                  )}
                </Flex>
              </Th>

              <Th
                pe='25px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  justifyContent='center'
                  // backgroundColor='red'
                  width='100px'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.code}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.name}
                      </Text>

                      {(obj.aadhar_verified || obj.pan_verified) && (
                        <chakra.div marginRight="10px"   >
                          <FaCheckCircle
                            color={obj.pan_verified ? 'green' : 'gray'}
                            style={{ fontSize: '20px' }} // Adjust the icon size
                          />
                        </chakra.div>
                      )}
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.phone_number}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.email}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {moment(obj.created_at).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex>
                      <Tooltip
                        label={
                          !permissions?.update
                            ? 'You do not have permission to edit'
                            : undefined
                        }
                        placement='top'
                        shouldWrapChildren>
                        <EditModal
                          Icon={<EditIcon />}
                          head={'Update Customer'}
                          func={FetchUserList}
                          currentUser={obj}
                          disabled={!permissions.update}
                        />
                      </Tooltip>
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/customeruser/${obj.id}`,
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
